<template>
    <b-container :id="`gas-${year}`">
      <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">
        <b-row>
          <b-col cols="9">
            Fuel Data
          </b-col>
          <b-col cols="3" class="text-right">
            <b-button size="sm" @click="requestDownload()">
              Export Fuel Data
            </b-button>
          </b-col>
        </b-row>
      </div>
      <ag-grid-vue style="width: 100%; height: 400px"
                   class="ag-theme-balham"
                   :gridOptions="topGridOptions"
                   :columnDefs="columnDefs"
                   :rowData="rowData"
                   :defaultColDef="defaultColDef"
                   :enterMovesDownAfterEdit="true"
                   @grid-ready="onGridReady"
                   @cell-clicked="onCellClicked"
                   @cell-editing-stopped="onCellEditingStopped">
        </ag-grid-vue>
        <ag-grid-vue style="width: 100%; height: 40px;"
                     class="ag-theme-balham"
                     :gridOptions="bottomGridOptions"
                     :headerHeight="0"
                     :columnDefs="bottomColumnDefs"
                     :rowData="bottomDataCalc"
                     :rowStyle="rowStyle"
        ></ag-grid-vue>

    </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import Bus from "../eventBus";
import {roundColumnValue} from "@/MetricUtils";
import {FileUtils} from "@/lib/FileUtils";

const PROPANE_METER = "propaneMeter";
    const GAS_METER = "gasMeter";

    const SizeEnum = {
        EM1: GAS_METER,
        EM2: PROPANE_METER
    };

    window.numberParser = function numberParser(params) {
        let parsedNumber = Number(params.newValue);
        return isNaN(parsedNumber) ? "ERROR" : parsedNumber;
    };

    export default {
        name: "GasMetricTable",
        props: {rows: Array, year: String, id: String, groupId: String},
        components: {
            AgGridVue
        },

        data() {
            return {
              metricYearVal: this.year,
              gridApi: null,
              gridColumnApi: null,
              bottomColumnDefs: null,
              columnDefs: null,
              defaultColDef: null,
              pinnedTopRowData: null,
              pinnedBottomRowData: null,
              topGridOptions: null,
              bottomGridOptions: null,
              rowData: this.rows,
              bottomData: [],
              rowStyle: {fontWeight: 'bold'},
              metricId: this.id,
              myGroupId: this.groupId,
              isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
            }
        },
        created() {
            Bus.$on('update-requests', this.sendMetricsUpdate);

        },
        beforeDestroy() {
            Bus.$off('update-requests', this.sendMetricsUpdate);
        },
        mounted() {
            this.gridApi = this.topGridOptions.api;
            this.gridColumnApi = this.topGridOptions.columnApi;
            this.$nextTick(this.sendMetricsUpdate(this.metricYearVal))
        },
        beforeMount() {

            this.columnDefs = [
                {
                    headerName: 'Month', field: 'month', pinned: "left",
                    lockPinned: true,
                    width: 100,
                    editable: false
                },
              {
                headerName: 'Year', field: 'year', pinned: "left",
                lockPinned: true,
                width: 75,
                editable: false
              },
              {
                headerName: 'Natural Gas Meter (Therms)',
                field: GAS_METER,
                valueParser: numberParser,
                editable: !this.isViewer,
                valueFormatter: params => roundColumnValue(params.data[params.column.colId], 2)
              },
              {
                headerName: 'Propane Meter (Gallons)',
                field: PROPANE_METER,
                valueParser: numberParser,
                editable: !this.isViewer,
                valueFormatter: params => roundColumnValue(params.data[params.column.colId], 2)
              }
            ];
          this.bottomColumnDefs = [
            {
              headerName: 'Month', field: 'month', pinned: "left",
              lockPinned: true,
              width: 100,
              editable: false
            },
            {
              headerName: 'Year', field: 'year', pinned: "left",
              lockPinned: true,
              width: 75,
              editable: false
            },
            {
              headerName: 'Natural Gas Meter (Therms)',
              field: GAS_METER,
              valueParser: numberParser,
              editable: !this.isViewer,
              valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
            },
            {
              headerName: 'Propane Meter (Gallons)',
              field: PROPANE_METER,
              valueParser: numberParser,
              editable: !this.isViewer,
              valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
            }
          ];
          this.bottomData = [
            {
              month: 'Total',
              year: '******',
              gasMeter: 'not as much',
              propaneMeter: 'a little more',
            }
          ];


            this.defaultColDef = {
                editable: true,
                resizable: true
            };

            this.pinnedTopRowData = getPinnedTopData();
            this.pinnedBottomRowData = getPinnedBottomData();

            this.topGridOptions = {alignedGrids: [], suppressHorizontalScroll: true};
            this.bottomGridOptions = {
                alignedGrids: [], enableCellExpressions: true, context: {
                    theNumber: 4
                }
            };
            this.topGridOptions.alignedGrids.push(this.bottomGridOptions);
            this.bottomGridOptions.alignedGrids.push(this.topGridOptions);

            let totalGas = 0;
            let totalPropane = 0;
          if (self.gridApi !== undefined) {
            self.gridApi.forEachNode(function (node) {
              if (node.data["year"] === event.data["year"]) {
                totalGas += Number(node.data[GAS_METER]) || 0;
                totalPropane += Number(node.data[PROPANE_METER]) || 0;
              }
            });
          }
          //this.calculateAndEmitTotals(totalGas, totalPropane, "beforeMount");
        },
      watch: {
        rows: function (newVal) {
          this.rowData = newVal;
        }
      },
      computed: {
        bottomDataCalc: function () {

          let self = this;
          let bottomRowsMap = new Map();
          let columnNames = [];
          Object.values(SizeEnum).map(key => {
            let result = 0;
            Object.values(self.rowData).forEach(row => {

                        result += self.safeNumber(row[key]);

                    });
                    columnNames.push(result);
                });

                let bottom =
                    {
                        month: "Total",
                        year: '******',
                        gasMeter: 0,
                        propaneMeter: 0,
                    };
                if (bottomRowsMap !== undefined) {
                    bottom = {
                        month: "Total",
                        year: '******',
                        gasMeter: Number(columnNames[0]),
                        propaneMeter: Number(columnNames[1])
                    };
                }
                return [bottom];
            }
        },
        methods: {
            onBtStopEditing() {
                this.gridApi.stopEditing();
            },
            cellValueChanged() {
                this.bottomGridOptions.api.refreshView();
            },
            onBtStartEditing(key, char, pinned) {
                this.gridApi.setFocusedCell(0, "month", pinned);
                this.gridApi.startEditingCell({
                  rowIndex: 0,
                  colKey: "month",
                  rowPinned: pinned,
                  keyPress: key,
                  charPress: char
                });
            },
          onBtNextCell() {
            this.gridApi.tabToNextCell();
          },
          requestDownload() {
            let self = this;
            this.$http.get(`metrics/download/${self.myGroupId}/${self.metricYearVal}/gas/wine`, {responseType: "blob"})
                .then(async response => {
                  FileUtils.saveExcelToDisk(response);
                });
          },
          onBtPreviousCell() {
            this.gridApi.tabToPreviousCell();
          },
          onBtWhich() {
            let cellDefs = this.gridApi.getEditingCells();
          },
          onGridReady(params) {
            this.gridApi = this.topGridOptions.api;
            this.gridColumnApi = this.topGridOptions.columnApi;
            const updateData = data => {
                    this.rowData = data;
                };
            },
            onCellClicked(event) {
            },
            calculateAndEmitTotals: function (totalGas, totalPropane, when) {
                this.bottomGridOptions.api.getRowNode('0').data[GAS_METER] = totalGas;
                this.bottomGridOptions.api.getRowNode('0').data[PROPANE_METER] = totalPropane;

                let gasEmission = {
                    gridType: "gasEmission",
                    totalGas: totalGas,
                    totalPropane: totalPropane,
                    year: this.metricYearVal,
                    when: when
                };
                Bus.$emit('grid-edited', gasEmission);
            },
            sendMetricsUpdate(year) {
                let self = this;
                let totalGas = 0;
                let totalPropane = 0;
                if (this.gridApi !== undefined) {
                    this.gridApi.forEachNode(function (node) {
                      if (node.data["year"] === year || node.data["year"] === year.toString()) {
                        totalGas += self.safeParseNumber(node, GAS_METER);
                        totalPropane += self.safeParseNumber(node, PROPANE_METER);
                      }
                    });
                }
                this.calculateAndEmitTotals(totalGas, totalPropane, "gridReady");
            },
            safeParseNumber: function (node, indexName, updateCell = false) {
                let isNotANumber = isNaN(node.data[indexName]);
                return isNotANumber ? 0 : node.data[indexName];
            },
            safeNumber: function (value, updateCell = false) {
                let isNotANumber = isNaN(value);
                return isNotANumber ? 0 : value;
            },
            updateGasMetrics: function (self) {
                if (self.gridApi !== undefined) {
                    let year = {};
                    let powerMetricsMonth = [];
                    self.gridApi.forEachNode(function (node) {
                        year = node.data["year"];
                        powerMetricsMonth.push({
                            month: node.data["month"],
                            gasMeter: self.safeParseNumber(node, GAS_METER),
                            propaneMeter: self.safeParseNumber(node, PROPANE_METER)
                        })
                    });
                    let metricYear = {
                        _id: this.id,
                        year: year,
                        groupId: this.myGroupId,
                        months: powerMetricsMonth
                    };

                    this.$http.put("/metrics/gas/" + this.metricId, JSON.stringify(metricYear), {
                        headers: {
                            'content-type': 'application/json'
                        }
                    }).then(response => {
                        // TODO Add Notification for Updated Metrics
                        if (self.id == null) {
                            self.id = response.data;
                          self.metricId = self.id;
                        }
                    }).catch(error => {
                        this.$toasted.show(`Saving Metric Failed: ${error.message}`,
                            {
                                containerClass: 'super-toasty',
                                iconPack: 'custom-class',
                                closeOnSwipe: true,
                                action: {
                                    text: 'DISMISS',
                                    onClick: (e, toastObject) => {
                                        toastObject.goAway(0);
                                    }
                                },
                                icon: {
                                    name: 'fa fa-times-circle fa-3x',
                                    after: false,
                                }
                            })
                            .goAway(5000);
                    })
                }
            },
            onCellEditingStopped(event) {
                let self = this;
                let totalGas = 0;
                let totalPropane = 0;
                if (self.gridApi !== undefined) {
                    self.gridApi.forEachNode(function (node) {
                        if (node.data["year"] === event.data["year"]) {
                            totalGas += self.safeParseNumber(node, GAS_METER);
                            totalPropane += self.safeParseNumber(node, PROPANE_METER);
                        }
                    });
                }

                this.updateGasMetrics(self);

                this.calculateAndEmitTotals(totalGas, totalPropane, "cellStoppedEditing");
                this.bottomGridOptions.api.redrawRows({rowNodes: [this.bottomGridOptions.api.getRowNode('0')]});
            }
        }
    }

    function getPinnedTopData() {
        return [
            {
                firstName: "##",
                lastName: "##",
                gender: "##",
                address: "##",
                mood: "##",
                country: "##"
            }
        ];
    }

    function getPinnedBottomData() {
        return [
            {
                firstName: "##",
                lastName: "##",
                gender: "##",
                address: "##",
                mood: "##",
                country: "##"
            }
        ];
    }

    function getCharCodeFromEvent(event) {
        event = event || window.event;
        return typeof event.which === "undefined" ? event.keyCode : event.which;
    }

    function isCharNumeric(charStr) {
        return !!/\d/.test(charStr);
    }

    function isKeyPressedNumeric(event) {
        let charCode = getCharCodeFromEvent(event);
        let charStr = String.fromCharCode(charCode);
        return isCharNumeric(charStr);
    }
</script>

<style scoped>

</style>
